import { over } from 'lodash/fp';
import React from 'react';

const withFormField =
	(WrappedComponent) =>
	({
		errorFormat,
		input,
		isCheckbox,
		label,
		questionnaire,
		meta,
		noOffsetBottom,
		noSpacing,
		noSpacingBottom,
		onBlur,
		showExclamationWhenInvalid,
		suppressErrorMessage,
		...other
	}) => {
		const error = meta.error || (!meta.dirtySinceLastSubmit && meta.submitError);
		const newProps = {
			...other,
			input: !onBlur ? input : { ...input, onBlur: over([input.onBlur, onBlur]) },
			formFieldProps: {
				error,
				errorFormat,
				hasError: Boolean(error),
				id: other.id || `${input.name}-id`,
				isActive: meta.active,
				isDisabled: other.disabled,
				isEmpty: Boolean(other.value),
				isFilled: Boolean(input.value),
				isCheckbox: isCheckbox || input.type === 'checkbox',
				isReadOnly: Boolean(other.readOnly),
				isTouched: meta.touched || meta.submitFailed, // TODO: this is hack to display submit errors
				isValid: meta.valid,
				label,
				noOffsetBottom,
				noSpacing,
				noSpacingBottom,
				noWrapError: other.noWrapError,
				questionnaire,
				showExclamationWhenInvalid,
				showValidationIcons: noSpacing,
				suppressErrorMessage,
			},
		};

		return <WrappedComponent {...newProps} />;
	};

export default withFormField;
